import { types as t, Instance } from 'mobx-state-tree';
import Sensor from '~/mst/models/device/sensor';

const SoundProSensor = t
  .compose(
    t.model({
      session_time: t.frozen(),
      filters: t.frozen(),
      measurement_mode: t.frozen()
    }),
    Sensor
  )
  .named('SoundPro');

export interface ISoundProSensor extends Instance<typeof SoundProSensor> {}

export default SoundProSensor;
